var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-canvas',[_c('add-global-task',{on:{"task-created":function (projectID, id, createAnother) { return _vm.handleTaskCreated(projectID, id, createAnother); },"canceled":function($event){return _vm.$router.go(-1)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }